import { UserAPI } from '@/api/backend-client'
import { Role } from '@/api/types'

export default [
    {
        name: 'pipeline_migration',
        path: '/migration/pipeline-migration',
        meta: {
            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
        },
        component: () => import(/* webpackChunkName: "pipeline_migration" */ '../../views/Migration/PipelineMigration.vue'),
    },
]
